import { render, staticRenderFns } from "./NsTopnavImageOverlay.vue?vue&type=template&id=10afe508&scoped=true&"
import script from "./NsTopnavImageOverlay.vue?vue&type=script&lang=js&"
export * from "./NsTopnavImageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavImageOverlay.vue?vue&type=style&index=0&id=10afe508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afe508",
  null
  
)

export default component.exports